import { default as createJSONRequest } from './create-request'

import escapeHTML from '../util/escapeHTML.js'
import querify from '../util/querify'

export const enrichPortfolio = (portfolioId) => createJSONRequest({
  url: `/api/portfolios/${portfolioId}/enrich`,
  method: 'POST',
})
